import "./styles.css";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import TabIcon from "@mui/icons-material/Tab";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import QuizIcon from "@mui/icons-material/Quiz";
import SummarizeIcon from "@mui/icons-material/Summarize";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import RedeemIcon from "@mui/icons-material/Redeem";

export const sidenavModules = [
  {
    id: 0,
    route: "/dashboard",
    name: "Dashboard",
    icon: <DashboardOutlinedIcon />,
  },
  {
    id: 1,
    name: "User Management",
    icon: <GroupOutlinedIcon />,
    subMenu: [
      {
        route: "/user/students",
        name: "Students",
        children: ["/user/students"],
      },
      {
        route: "/user/trainers",
        name: "Trainers",
        children: ["/user/trainers", "/user/trainers/add-trainer"],
      },
      {
        route: "/user/sub-admins",
        name: "Sub Admins",
        children: ["/user/sub-admins", "/user/manage-permissions"],
      },
    ],
  },
  {
    id: 2,
    name: "Courses",
    icon: <SchoolOutlinedIcon />,
    subMenu: [
      {
        route: "/courses",
        name: "Courses",
        children: ["/courses", "/courses/add-courses"],
      },
      {
        route: "/courses/enrolled-students",
        name: "Enrolled Students",
        children: ["/courses/enrolled-students"],
      },
      {
        route: "/courses/course-categories",
        name: "Course Categories",
        children: [
          "/courses/course-categories",
          "/courses/add-coursesCategory",
        ],
      },
      {
        route: "/courses/feedback-questions",
        name: "Feedback Questions",
        children: ["/courses/feedback-questions"],
      },
    ],
  },
  {
    id: 3,
    name: "Batch",
    icon: <TabIcon />,
    route: "/batch",
  },
  {
    id: 4,
    name: "Webinars",
    icon: <LanguageIcon />,
    route: "/webinar",
  },
  {
    id: 5,
    name: "Blogs & More",
    icon: <RateReviewOutlinedIcon />,
    subMenu: [
      {
        route: "/blog",
        name: "Blogs",
        children: ["/blog", "blog/add-blog"],
      },
      {
        route: "/blog/blog-categories",
        name: "Blog Categories",
      },
      {
        route: "/mock-test",
        name: "Mock Tests",
        children: ["/mock-test", "/mock-test/new-mock-test"],
      },
    ],
  },
  {
    id: 6,
    name: "Calendar",
    icon: <CalendarTodayRoundedIcon />,
    route: "/calendar",
  },
  {
    id: 7,
    // name: "Query & Announcement",
    name: "Announcement",
    icon: <RateReviewOutlinedIcon />,
    subMenu: [
      {
        route: "/query/announcement",
        name: "Announcement",
        children: ["/query/announcement"],
      },
    ],
  },
  // {
  //   id: 8,
  //   name: "Careers",
  //   icon: <WorkOutlineIcon />,
  //   subMenu: [
  //     {
  //       route: "/careers/company-role",
  //       name: "Company Roles",
  //       children: ["/careers/company-role", "/careers/newjob"],
  //     },
  //     {
  //       route: "/careers/trainer",
  //       name: "Trainers",
  //       children: ["/careers/trainer"],
  //     },
  //   ],
  // },
  {
    id: 9,
    name: "ROI & Reports",
    icon: <SummarizeIcon />,
    subMenu: [
      {
        route: "/roi",
        name: "ROI",
        children: ["/roi"],
      },
      // {
      //   route: "/roi/paymentReport",
      //   name: "Payment Report",
      // },
    ],
  },
  {
    id: 10,
    name: "Referral & Offers",
    icon: <RedeemIcon />,
    route: "/offers",
  },
];

export const roles = {
  ADMIN: "Admin",
  SUB_ADMIN: "Sub_admin",
};

export const jobStatus = {
  NEW: "New",
  OPENDED: "Opened",
  SHORT_LISTED: "Short_Listed",
  REJECTED: "Rejected",
  HIRED: "Hired",
};

export const slugFilterType = {
  COURSE: "Course",
  BLOG: "Blog",
  WEBINAR: "Webinar",
  COURSE_CATEGORY: "Category",
};
